module.exports = __webpack_public_path__ + "img/list_ppt.ace41346.webp";